import { Modifier } from "@/dto/modifer";
import {
  getFromLocalStorage,
  removeFromLocalStorage,
  saveToLocalStorage,
} from "./localStorageUtils";
import { RetailCartItem } from "@/dto/retailCartItem";
import { LocalStorageKey } from "./storageKeys";

export const addToCart = (item: {
  id: string;
  name: string;
  price: number;
  quantity: number;
  modifiers: Modifier[];
  specialInstructions: string;
  subtotal: number;
  total: number;
  cartId: string;
}) => {
  const cartItem: RetailCartItem = {
    key: item.cartId,
    value: item,
  };
  const cart = getFromLocalStorage<RetailCartItem[]>(LocalStorageKey.CART, []);
  cart?.push(cartItem);
  saveToLocalStorage(LocalStorageKey.CART, cart);
};

export const getCartItems = (): RetailCartItem[] => {
  const cart = getFromLocalStorage(LocalStorageKey.CART, []);
  return cart;
};

export const clearCart = () => {
  removeFromLocalStorage(LocalStorageKey.CART);
};

export const clearServiceCart = () => {
  removeFromLocalStorage(LocalStorageKey.SERVICE_CART);
};
